import { Button } from "rsuite";
import { ArrowClockwise } from "react-bootstrap-icons";
import { HeaderProps } from "../my-type";
import { GoChevronLeft } from "react-icons/go";

export default function Header({ HeaderTitle, isShowRefresh, OnReturn, OnRefresh }: HeaderProps) {
  return <div className="fleet-toolbar" aria-label={HeaderTitle}>
    <Button appearance="default" onClick={OnReturn} startIcon={<GoChevronLeft aria-hidden="true" />}>返回</Button>
    {isShowRefresh && <Button appearance="default" onClick={OnRefresh} startIcon={<ArrowClockwise aria-hidden="true" />}>重新整理</Button>}
  </div>;
}
